/**
 * Notification inbox DTOs (F-110): the shapes `GET /api/notifications` serves
 * and the client's bell renders.
 *
 * Notifications are DERIVED server-side from the board docs (see the server's
 * `core/notifications/`), never written by the client — the same reasoning as
 * mentions being derived from bodies rather than stored (docs/04 §2). A
 * client that posts a comment and then dies must still notify the person it
 * tagged, and a client must not be able to invent a notification for someone.
 */
export const NOTIFICATION_KINDS = [
    "mention",
    "reply",
    "element-comment",
];
export function isNotificationKind(value) {
    return typeof value === "string" && NOTIFICATION_KINDS.includes(value);
}
/** Short label for the inbox row ("mentioned you", "replied", …). */
export const NOTIFICATION_KIND_LABELS = Object.freeze({
    mention: "mentioned you",
    reply: "replied in your thread",
    "element-comment": "commented on your element",
});
/** How much comment body an inbox row carries. */
export const NOTIFICATION_EXCERPT_MAX = 140;
/**
 * Collapse a comment body into a one-line inbox excerpt. Capped so a
 * pathological 10 kB comment cannot bloat every recipient's inbox row.
 */
export function notificationExcerpt(body) {
    const flat = body.replace(/\s+/g, " ").trim();
    return flat.length <= NOTIFICATION_EXCERPT_MAX
        ? flat
        : `${flat.slice(0, NOTIFICATION_EXCERPT_MAX - 1).trimEnd()}…`;
}
//# sourceMappingURL=notifications.js.map